import { useMutation, useQueryClient } from '@tanstack/react-query'
import supabase from 'lib/supabase-browser'
import { User } from 'lib/types/generated-types'

export const useUpdateUser = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async ({ userId, data }: { userId: string; data: Partial<User> }) => {
      const { data: updatedUser, error } = await supabase
        .from('users')
        .update(data)
        .eq('id', userId)
      if (error) throw error
      return updatedUser
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['user'] })
      },
    }
  )
}
